export default {"src":"/_next/static/image/public/images/logo_aster.7abe3a1856a1df744ad9376ea0212e23.svg","height":31,"width":106};